import React from 'react';
import { waLink, WaIcon } from '../App';

export default function Fab() {
  return (
    <a href={waLink("Hi Kreme Tops! I'd love to order a cake.")} target="_blank" rel="noopener noreferrer"
      style={{ position:'fixed', right:22, bottom:22, zIndex:80, display:'inline-flex', alignItems:'center', gap:10, background:'var(--wa)', color:'#fff', fontWeight:700, fontSize:14.5, padding:'13px 20px', borderRadius:40, boxShadow:'0 16px 30px -10px rgba(31,170,95,.6)', transition:'transform .18s', textDecoration:'none' }}
      onMouseOver={e => e.currentTarget.style.transform='translateY(-3px) scale(1.02)'}
      onMouseOut={e => e.currentTarget.style.transform=''}>
      <WaIcon size={20} />Chat to order
    </a>
  );
}
